module.exports = __webpack_public_path__ + "img/Mask group@2x(2).035dd76d.png";